import { CreateTagData, Tag } from '../../types/agentTypes'
import { axiosClient } from '../axiosClient'

export const tagsFunctions = {
  fetchTagsList: async (): Promise<Tag[]> => {
    return await axiosClient.get('api/tags/')
  },

  createTag: async (data: CreateTagData): Promise<Tag> => {
    return await axiosClient.post('api/tags/', data)
  },

  deleteTag: async (tagId: string): Promise<void> => {
    await axiosClient.delete(`api/tags/${tagId}/`)
  },
}
